import React, { useEffect, useState } from "react";

const OrderProgress = ({ dueTime, assignTime }) => {
    const [timeLeft, setTimeLeft] = useState(0);
    const [isOverdue, setIsOverdue] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const updateProgress = () => {
            const now = Date.now();
            const totalDuration = (dueTime - assignTime) / (1000 * 60 * 60); // Total hours assigned
            const elapsedTime = (now - assignTime) / (1000 * 60 * 60); // Hours since assigned
            const remainingTime = (dueTime - now) / (1000 * 60 * 60); // Hours left
            setTimeLeft(Math.round(remainingTime));
            setIsOverdue(now > dueTime);

            // Ensure progress is within 0-100%
            const progressPercentage = isOverdue ? 100 : Math.round((elapsedTime / totalDuration) * 100, 100);
            setProgress(progressPercentage);
        };

        updateProgress(); // Initial calculation
        const timer = setInterval(updateProgress, 60000); // Update every minute

        return () => clearInterval(timer);
    }, [dueTime, assignTime]);

    return (
        <div className="flex items-center">
            <p className="accSingleInvoiceText text-nowrap mr-2">
                {isOverdue ? "Overdue" : `${timeLeft} hrs left`}
            </p>
            <div className="progress-bar-container">
                <div
                    className={`progress-bar ${isOverdue ? "overdue" : ""}`}
                    style={{ width: `${100-progress}%` }}
                ></div>
            </div>
        </div>
    );
};

export default OrderProgress;
